import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

const Charts = ({ damageData, darkMode }) => {
  // Format data for bar chart
  const barData = [
    {
      name: 'Strength',
      damage: damageData.breakdown.strength,
    },
    {
      name: 'Fruit',
      damage: damageData.breakdown.fruit,
    },
    {
      name: 'Weapon',
      damage: damageData.breakdown.weapon,
    },
  ].filter(item => item.damage > 0);

  // Format data for pie chart
  const pieData = [
    { name: 'Strength', value: damageData.breakdown.strength },
    { name: 'Fruit', value: damageData.breakdown.fruit },
    { name: 'Weapon', value: damageData.breakdown.weapon },
  ].filter(item => item.value > 0);

  const COLORS = ['#3B82F6', '#10B981', '#F59E0B'];
  
  const cardClass = darkMode 
    ? 'bg-card-dark shadow-card-dark border border-gray-700' 
    : 'bg-white shadow-card-light';
  
  const textClass = darkMode 
    ? 'text-gray-100' 
    : 'text-gray-900';
  
  // Common tooltip style for both charts
  const tooltipStyle = {
    backgroundColor: darkMode ? '#374151' : '#FFFFFF',
    borderColor: darkMode ? '#6B7280' : '#E5E7EB',
    color: darkMode ? '#F9FAFB' : '#111827',
    boxShadow: darkMode ? '0 4px 6px rgba(0, 0, 0, 0.3)' : '0 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '0.5rem',
    borderWidth: '2px'
  };

  const itemStyle = {
    color: darkMode ? '#F9FAFB' : '#111827',
    fontWeight: 500
  };

  const labelStyle = {
    color: darkMode ? '#F3F4F6' : '#1F2937', 
    fontWeight: 600
  };
  
  return (
    <div className={`p-6 rounded-lg transition-theme duration-300 ease-in-out ${cardClass}`}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div>
          <h3 className={`text-xl font-semibold mb-4 ${textClass}`}>Damage Distribution</h3>
          <div className="overflow-x-auto">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart
                data={barData}
                margin={{
                  top: 20, right: 30, left: 20, bottom: 5,
                }}
              >
                <XAxis dataKey="name" stroke={darkMode ? '#9CA3AF' : '#4B5563'} />
                <YAxis stroke={darkMode ? '#9CA3AF' : '#4B5563'} />
                <Tooltip 
                  contentStyle={tooltipStyle}
                  itemStyle={itemStyle}
                  labelStyle={labelStyle}
                />
                <Legend />
                <Bar dataKey="damage" fill={darkMode ? '#3B82F6' : '#4F46E5'} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        
        <div>
          <h3 className={`text-xl font-semibold mb-4 ${textClass}`}>Damage Percentage</h3>
          <div className="overflow-x-auto">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={pieData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={100}
                  dataKey="value"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                >
                  {pieData.map((entry, index) => (
                    <Cell 
                      key={`cell-${index}`} 
                      fill={COLORS[index % COLORS.length]} 
                      stroke={darkMode ? '#1F2937' : '#FFFFFF'} 
                    />
                  ))}
                </Pie>
                <Tooltip 
                  contentStyle={tooltipStyle}
                  itemStyle={itemStyle}
                  labelStyle={labelStyle}
                />
                <Legend 
                  formatter={(value) => <span style={{ color: darkMode ? '#F9FAFB' : '#111827' }}>{value}</span>} 
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Charts;
